import { PaymentRowKindEnum, TPaymentRowKind } from '../types/ManagePayments';
import { TPaymentPresentationStrategy } from '../types/PaymentKindStrategy';
import {
  batchPresentationStrategy,
  scheduledPaymentPresentationStrategy,
  scheduledTransferPresentationStrategy
} from './paymentPresentationStrategyExtensions';

/**
 * The single source of truth for "how does a row of this kind render itself and which modal does
 * it open" - consumed by PaymentsTable (avatar/Type column) and Payments (modal routing), which no
 * longer need their own `row.kind === ...`/`selectedPayment.kind === ...` branches for this. This
 * file is just the registry/lookup ("process") - the actual per-kind implementations live in
 * paymentPresentationStrategyExtensions.ts, so adding a new kind's rendering means adding a new
 * export there and one line here, never editing this lookup logic itself. See the README's
 * "Extending: Adding a New Row Kind" section.
 */
export const PAYMENT_PRESENTATION_STRATEGIES: Record<
  TPaymentRowKind,
  TPaymentPresentationStrategy
> = {
  [PaymentRowKindEnum.BATCH]: batchPresentationStrategy,
  [PaymentRowKindEnum.SCHEDULED_PAYMENT]: scheduledPaymentPresentationStrategy,
  [PaymentRowKindEnum.PENDING_SCHEDULED_PAYMENT]: scheduledPaymentPresentationStrategy,
  [PaymentRowKindEnum.SCHEDULED_TRANSFER]: scheduledTransferPresentationStrategy
};

export const getPaymentPresentationStrategy = (
  kind: TPaymentRowKind
): TPaymentPresentationStrategy => PAYMENT_PRESENTATION_STRATEGIES[kind];
